<template>
    <v-form v-model="validForm" autocomplete="off" method="post" action="/resource_users">
        <v-card>
            <v-card-title>{{ title }}</v-card-title>
            <v-card-text>
                <CsrfToken />
                <select-item name="resource_id" v-model="data.resource" :errors="field_errors.resource_id"
                    @change="field_errors.resource_id = null" action="/resources/list" item-value="id" item-text="name"
                    label="Risorsa" required prepend-icon="domain" />

                <v-text-field name="name" v-model="data.name" :error-messages="field_errors.name"
                    @change="field_errors.name = null" label="Username" type="text" required :rules="rules.name"
                    prepend-icon="account_box" autocomplete="off" />

                <v-text-field name="email" v-model="data.email" :error-messages="field_errors.email"
                    @change="field_errors.email = null" label="E-mail" type="email" required :rules="rules.email"
                    prepend-icon="email" autocomplete="off" />

                <v-text-field name="password" v-model="data.password" :error-messages="field_errors.password"
                    @change="field_errors.password = null" label="Password" clearable :rules="rules.password"
                    prepend-icon="password" autocomplete="off" :type="showPwd ? 'text' : 'password'"
                    :append-icon="!showPwd ? 'visibility' : 'visibility_off'" @click:append="showPwd = !showPwd" />
                <a @click="generatePassword">Genera password casuale</a>

                <input v-for="(p,i) in permissions" type="hidden" :name="'permissions[' + i + ']'" v-model="permissions[i]"> 
            </v-card-text>
            <v-card-actions>

                <v-btn color="amber" @click="openPopUpPermission = true" dark>
                    <v-icon left>lock</v-icon>
                    Permessi
                </v-btn>
                <v-spacer></v-spacer>

                <v-btn type="submit" color="primary" :disabled="!canSubmit">
                    <v-icon left>send</v-icon>
                    {{ isNew ? 'Crea' : 'Salva' }}
                </v-btn>
            </v-card-actions>
        </v-card>

        <v-dialog :value="openPopUpPermission" persistent max-width="800" scrollable>
            <resource-permissions :permissions="permissions" @close="openPopUpPermission=false"></resource-permissions>
        </v-dialog>

        
    </v-form>
</template>
<script>
import { Vuelidator, Rule } from '../Vuelidator/index.js';

export default {
    props: {
        value: { type: Object, },
        permissions: {type: Object, required:true},
        fieldErrors: { type: Array },
    },
    data() {
        const validator = new Vuelidator({
            name: [Rule.required(), Rule.string(), Rule.min(3)],
            email: [Rule.required(), Rule.min(3)],// Rule.email(),
            password: [Rule.required(), Rule.string(), Rule.min(3)],
            resource_id: [Rule.required(),],
        });
        const rules = validator.getRules();

        const data = Object.assign({
            id: null,
            name: '',
            email: '',
            password: '',
            resource_id: null,
            resource: null,
        }, this.value || {});

        const field_errors = Object.assign({
            name: null,
            email: null,
            password: null,
            resource_id: null,
        }, this.fieldErrors || {});

        return {
            data,
            field_errors,
            rules,

            validForm: false,
            loading: false,
            error: null,
            showPwd: false,
            openPopUpPermission: false
        };
    },
    computed: {
        canSubmit() { return this.validForm; },
        isNew() { return this.data.id === null },
        title() {
            return this.isNew ? 'Nuovo accesso risorsa' : 'Modifica accesso risorsa';
        },

    },
    methods: {
        generatePassword() {
            this.data.password = Math.random().toString(36).substring(2, 10);
            this.showPwd = true;
        },
    },
    watch: {
        'data.resource': function () {
            this.data.resource_id = this.data.resource?.id;
            if (this.data.resource?.email)
                this.data.email = this.data.resource?.email;
            if (this.data.resource?.referent)
                this.data.name = this.data.resource?.referent;
        },
    },
}
</script>